import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LottoDetails } from './models/lotto.model';
import { ApiService } from '../../../shared/services/core/api.service';
import { CustomField } from '../../../shared/models/custom-field.model';

/** Version 2
 *
 * Unlike V1, these methods do not write to the store.
 * Data is returned as plain Observables, keeping state management
 * out of the service for better scalability and flexibility.
 */
@Injectable({ providedIn: 'root' })
export class LottoApiService {
  private readonly api = inject(ApiService);

  fetchLottos(): Observable<LottoDetails[]> {
    return this.api.get<LottoDetails>('lottos/v2');
  }

  fetchLottoById(id: number): Observable<LottoDetails> {
    return this.api.getById<LottoDetails>('lottos/v2', id.toString());
  }

  enterLotto(id: number, entries: number, customFields: Partial<CustomField>[] = []): Observable<any> {
    return this.api.post(`lottos/v2/${id}/enter`, { LottoId: id, NumberOfEntries: entries, CustomFields: customFields });
  }
}
